<div class="cviewsurvey__classic-form">

    <!-- Form Data -->
    <div class="cviewsurvey__classic-form--question-wrap">
        <form class="cviewsurvey__classic-form--item-wrap">
            <!-- Step Form Item -->
            <div class="step-form-item">
                <div class="cviewsurvey__classic-form--item-inner" *ngFor="let lists of questiondisplay?.template_questions ;  let i = index">
                    <div *ngIf="selectedindexx ==  i">
                        <!-- Question Details -->
                        <div class="cviewsurvey__classic-form--item-question-details">
                            <div class="cviewsurvey__classic-form--item-question-index">Question {{i+1}}.</div>
                            <div class="cviewsurvey__classic-form--item-question-text">{{lists.question}}
                            </div>
                        </div>
                        <!-- End Question Details -->

                        <!-- Multi Choice Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 1">
                            <div class="cviewsurvey__single-select" *ngIf="lists.question_type_id == 1">
                                <ul class="cviewsurvey__single-select-list">
                                    <li class="cviewsurvey__single-select-item" *ngFor="let option  of lists.template_answers">
                                        <input class="mts__input" id="{{option.id}}" type="radio" name="singleChoice">
                                        <label class="mts__input-check" for="{{option.id}}">{{option.template_answer}}</label>
                                    </li>


                                </ul>
                            </div>
                        </div>
                        <!-- End Multi Choice Question -->

                        <!-- Rating Scale Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 2">
                            <div class="cviewsurvey__rating-scale">
                                <ul class="cviewsurvey__rating-scale-list">
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale0" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale0">0</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale1" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale1">1</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale2" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale2">2</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale3" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale3">3</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale4" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale4">4</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale5" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale5">5</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale6" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale6">6</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale7" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale7">7</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale8" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale8">8</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale9" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale9">9</label>
                                    </li>
                                    <li class="cviewsurvey__rating-scale-item">
                                        <input class="rat__input" id="ratScale10" type="radio" name="ratingScale">
                                        <label class="rat__input-lab" for="ratScale10">10</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- End Rating Scale Question -->

                        <!-- Start Rating Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 3">
                            <div class="cviewsurvey__star-rating">
                                <div class="cviewsurvey__icons-rating-list">
                                    <input type="radio" id="star-1" class="star-check d-none" name="star" checked />
                                    <input type="radio" id="star-1" class="star-check" name="star" />
                                    <label for="star-1" class="star-icon"></label>
                                    <input type="radio" id="star-2" class="star-check" name="star" />
                                    <label for="star-2" class="star-icon"></label>
                                    <input type="radio" id="star-3" class="star-check" name="star" />
                                    <label for="star-3" class="star-icon"></label>
                                    <input type="radio" id="star-4" class="star-check" name="star" />
                                    <label for="star-4" class="star-icon"></label>
                                    <input type="radio" id="star-5" class="star-check" name="star" />
                                    <label for="star-5" class="star-icon"></label>
                                </div>
                            </div>
                        </div>
                        <!-- End Start Rating Question -->

                        <!-- NPS Rating Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 4">
                            <ul class="cviewsurvey__nps-scale-list">
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale0" type="radio" name="nps" value="0">
                                    <label class="rat__input-lab" for="npsScale0">0</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale1" type="radio" name="nps" value="1">
                                    <label class="rat__input-lab" for="npsScale1">1</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale2" type="radio" name="nps" value="2">
                                    <label class="rat__input-lab" for="npsScale2">2</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale3" type="radio" name="nps" value="3">
                                    <label class="rat__input-lab" for="npsScale3">3</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale4" type="radio" name="nps" value="4">
                                    <label class="rat__input-lab" for="npsScale4">4</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale5" type="radio" name="nps" value="5">
                                    <label class="rat__input-lab" for="npsScale5">5</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale6" type="radio" name="nps" value="6">
                                    <label class="rat__input-lab" for="npsScale6">6</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale7" type="radio" name="nps" value="7">
                                    <label class="rat__input-lab" for="npsScale7">7</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale8" type="radio" name="nps" value="8">
                                    <label class="rat__input-lab" for="npsScale8">8</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale9" type="radio" name="nps" value="9">
                                    <label class="rat__input-lab" for="npsScale9">9</label>
                                </li>
                                <li class="cviewsurvey__nps-scale-item">
                                    <input class="rat__input" id="npsScale10" type="radio" name="nps" value="10">
                                    <label class="rat__input-lab" for="npsScale10">10</label>
                                </li>
                            </ul>
                        </div>
                        <!-- END NPS Rating Question -->

                        <!-- Select Dropdown Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 5">
                            <select class="cviewsurvey__select-option" name="" id="">
                                <option  *ngFor="let option  of lists.template_answers"  value="option.template_answer">{{option.template_answer}}</option>
                             </select>


                        </div>
                        <!-- End Select Dropdown Question -->

                        <!-- Comment Box -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 6">
                            <div class="cviewsurvey__textarea">
                                <textarea class="cviewsurvey__textarea-option-ans" placeholder="Please enter your response" maxlength="10000" spellcheck="false"></textarea>
                            </div>
                            <!-- <div class="multiline_helper">
                                <p><span>Hit <b>Shift + Enter</b> for new line</span></p>
                            </div> -->
                        </div>
                        <!-- End Comment Box -->

                        <!-- Calender Select Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 8">
                            <div class="cviewsurvey__calender-select">
                                <input type="date" class="cviewsurvey__calender-select-input">
                            </div>
                        </div>
                        <!-- End Calender Select Question -->

                        <!-- Custom Form Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 9">
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">First Name</label>
                                        <input type="text" name="firstName" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Last Name</label>
                                        <input type="text" name="lastName" value="" class="border-radius  text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Email</label>
                                        <input type="email" name="email" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Mobile No.</label>
                                        <input type="tel" name="phone" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-sm-12">
                                    <div class="field-wrapper">
                                        <label class="floating-label">Address</label>
                                        <input type="text" name="address" value="" class="border-radius text-field-input">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Custom Form Question -->

                        <!-- Check Box Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 10">
                            <div class="cviewsurvey__signle-select">
                                <ul class="cviewsurvey__single-select-list">
                                    <li class="cviewsurvey__single-select-item" *ngFor="let option  of lists.template_answers">
                                        <input class="rcheck__input" id="rcheck0" type="radio" name="radio-check">
                                        <label class="rcheck__input-label" for="rcheck0">{{option.template_answer}}</label>
                                    </li>

                                    <!-- <div >
                                        <input type="checkbox" name="option" value="option" readonly disabled>
                                        <label for="option">{{option.template_answer}} </label><br>
                                    </div> -->
                                </ul>
                            </div>
                        </div>
                        <!-- End Check Box Question -->

                        <!-- Yes/No Question -->
                        <div class="cviewsurvey__classic-form--item-question-options" *ngIf="lists.question_type_id == 14">
                            <ul class="cviewsurvey__yes-no-select-list">
                                <li class="cviewsurvey__yes-no-item">
                                    <input class="cvcheck__input" id="yes" type="radio" name="yes-no">
                                    <label class="cvcheck__input-label" for="yes">
                                        <div class="details">
                                            <span class="icon">
                                                <i class="fas fa-check"></i>
                                            </span>
                                            <span class="title">Yes</span>
                                        </div>
                                    </label>
                                </li>

                                <li class="cviewsurvey__yes-no-item">
                                    <input class="cvcheck__input" id="no" type="radio" name="yes-no">
                                    <label class="cvcheck__input-label" for="no">
                                        <div class="details">
                                            <span class="icon">
                                                <i class="fas fa-times"></i>
                                            </span>
                                            <span class="title">No</span>
                                        </div>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <!-- End Yes/No Question -->

                        <div class="cviewsurvey__classic-form--item-footer">

                            <div class="cviewsurvey__classic-form--item-footer-action">
                                <div class="d-none cviewsurvey__classic-form--item-footer-logo">
                                    <img src="assets/logo-light.svg" alt="logo">
                                </div>
                                <div class="mx-auto d-flex" style="position: absolute; bottom: 10px; right: 10px;">
                                    <button class=" arrow-btn arrow-left " *ngIf="!(selectedindexx==0 ) " (click)="indexchange(selectedindexx-1) ">
                                        <img class="btn-image " src="assets/angle-arrow-left.svg " alt="arrow-left ">
                                    </button>
                                    <button class="arrow-btn arrow-right next action-button " (click)="indexchange(selectedindexx+1 ) ">
                                        <img class="btn-image " src="assets/angle-arrow-right.svg " alt="arrow-right ">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--End Step Form Item -->
        </form>
    </div>
    <!-- End Form Data -->

</div>